import React from 'react';
import PropTypes from 'prop-types';
import { Paper, List, Subheader, Toggle } from 'material-ui';
import style from '../../../styles/styles';
import styles from './QuizSetting.css';
import Loading from '../../common/Loading/Loading';
import withTranslation from '../../../hoc/withTranslation';

class QuizSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func,
    };

    static defaultProps = {
        app: null,
        loading: false,
    };

    handleToggledAllowMultipleAnswers = (event, isInputChecked) => {
        this.props.editConfiguration('allow_multiple_answers', isInputChecked);
    };
    render() {
        const {
            loading,
            app
        } = this.props;
        let content;
        if (loading) {
            content = <Loading paper={false} />;
        } else {
            content = <div>
                <Toggle
                    style={styles.toggle}
                    label={this.props.t('settings_page.allow_multiple_answers')}
                    toggled={app.configurations.allow_multiple_answers}
                    labelPosition="right"
                    onToggle={this.handleToggledAllowMultipleAnswers}
                />
            </div>;
        }
        return <Paper>
            <List>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('module.quiz.name')}
                </Subheader>

                <div style={style.paper}>
                    {content}
                </div>
            </List>
        </Paper>;
    }
}

export default withTranslation(QuizSetting);



// WEBPACK FOOTER //
// src/components/common/QuizSetting/QuizSetting.js